import React, { useCallback, useEffect, useReducer, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import ReactSelect, { components } from "react-select";
import AsyncSelect from "react-select/async";
import Button from "./Button";
import * as commonData from "../../Common";
import { useParams } from "react-router-dom";
import Loading from "./Loading";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import CustomOption from "../CustomOption";
import { DateRangePicker } from "rsuite";
import ReactSelectNew from "../React_Select/ReactSelectNew";

const CustomFilter = ({
  children,
  show,
  onClose,
  title,
  filterSubmit,
  isFilterCreate,
  filterText,
  createFilterByView,
  values,
  isEdit,
  isKanban,
  type,
}) => {
  const params = useParams();
  const apiUrl = commonData.commonData().apiUrl;
  const [state, setState] = useState({
    columns: [],
    formdata: {
      group_by: "assign_to",
    },
    searchTerm: "",
    users: [],
  });
  const [apiData, setApiData] = useState([]);

  useEffect(() => {
    (async () => {
      const resp = await fetch(`${apiUrl}tattle/attributes`, {
        method: "POST",
        body: JSON.stringify({
          app_token: commonData.getCommonData().app_token,
          attribute_set_key: params.attribute_set_key,
          attribute_status: true,
        }),
      });

      const resdata = await resp.json();
      if (resdata.code === 200) {
        setState((state) => {
          return {
            ...state,
            columns: resdata?.data,
          };
        });
      }
    })();
  }, []);
  const handleFormChange = (evt) => {
    setState((state) => {
      return {
        ...state,
        formdata: {
          ...state.formdata,
          [evt.target.name]: evt.target.value,
        },
      };
    });
  };
  useEffect(() => {
    if (!show) {
      setState((state) => {
        return {
          ...state,
          formdata: { group_by: "assign_to" },
        };
      });
    }
  }, [show]);
  const convertDateFormat = (date) => {
    let convertdate = null;
    if (date) {
      convertdate = moment(date).format("YYYY-MM-DD");
    }
    return convertdate;
  };

  const datePickerHandler = (evt, field) => {
    const date = convertDateFormat(evt);
    setState((state) => {
      return {
        ...state,
        formdata: {
          ...state.formdata,
          [field]: date,
        },
      };
    });
  };
  const dateRangePickerHandler = (evt, field, type) => {
    let formdata = { ...state.formdata };
    if (evt !== null) {
      if (type === "timestamp") {
        formdata = {
          ...formdata,
          range: {
            ...formdata.range,
            [field]: evt.map((ev) => Math.floor(new Date(ev).getTime() / 1000)),
          },
        };

        setState((state) => {
          return {
            ...state,
            formdata: formdata,
          };
        });
      } else {
        const date_select = [
          convertDateFormat(evt[0]),
          convertDateFormat(evt[1]),
        ];

        formdata = {
          ...formdata,
          range: {
            ...formdata.range,
            [field]: date_select,
          },
        };

        setState((state) => {
          return {
            ...state,
            formdata: formdata,
          };
        });
      }
    } else {
      if (type === "timestamp") {
        formdata = {
          ...formdata,
          range: {
            ...formdata.range,
            [field]: [],
          },
        };
      } else {
        formdata = {
          ...formdata,
          [field]: [],
        };
      }

      setState((state) => {
        return {
          ...state,
          formdata: formdata,
        };
      });
    }
  };

  const handleFormChangeReactSelect = useCallback(
    (evt, name, field) => {
      if (Array.isArray(evt)) {
        if (name === "custom_effort") {
          const iddd = evt.map((item) => item.value);
          setState((state) => {
            return {
              ...state,
              formdata: {
                ...state.formdata,
                [name]: { ...state.formdata?.[name], [field]: [...iddd] },
              },
            };
          });
        } else {
          setState((state) => {
            return {
              ...state,
              formdata: {
                ...state.formdata,
                [name]: evt.map((item) => item.value),
              },
            };
          });
        }
      } else {
        setState((state) => {
          return {
            ...state,
            formdata: {
              ...state.formdata,
              [name]: evt?.value,
            },
          };
        });
      }
    },
    [state.columns, state.formdata, values]
  );
  function isValidJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        formdata: {
          group_by: "assign_to",
          ...JSON?.parse(values?.value || values?.filter_value || "{}"),
        },
      };
    });
  }, [values]);
  const getPeoplesCall = async (evt, apiUrl) => {
    if (evt && state.users.length > 0) {
      return state.users.filter((item) =>
        item.label.toLowerCase().includes(evt.toLowerCase())
      );
    }
    const resp = await fetch(apiUrl);
    const rdata = await resp.json();
    const newdata = Object.entries(rdata).map(([key, val]) => {
      return (
        val.is_active == 1 && {
          ...val,
          label: val.name,
          value: val.user_uuid,
          profile_image: val.profile_image,
        }
      );
    });

    setState((state) => {
      return {
        ...state,
        users: newdata,
      };
    });
    return newdata;
  };
  const getApiCall = async (evt, api, type, field) => {

    if (type !== "company_name" && apiData[field]) {
      return apiData[field].filter((item) =>
        item.label.toLowerCase().includes(evt.toLowerCase())
      );
    }
    let response;
if (type === "company_name") {
  const requestBody = {
    search: evt || "",
    company_name: state.formdata[type] || [],
  };
  response = await fetch(api, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });
} else {
  response = await fetch(`${api}`);
}


    const rdata = await response.json();
    if (type === "api" || type === "product") {
      let apidata = rdata.map((item) => ({
        label: item.value,
        value: item.id,
      }));
      setApiData((state) => {
        return {
          ...state,
          [field]: apidata,
        };
      });
      return apidata;
    }
    if (
      type === "account_manager" ||
      type === "tse_owner" ||
      type === "sales_manager"
    ) {
      const { data } = rdata;

      let st_fields = data.map((ite) => ({
        label: ite.name,
        value: ite.user_uuid,
      }));

      setApiData((state) => {
        return {
          ...state,
          [field]: st_fields,
        };
      });

      return st_fields;
    }
    if (type === "customer_type") {
      let customertypedata = Object.keys(rdata).map((ke) => ({
        label: rdata[ke].customer_type,
        value: ke,
      }));
      setApiData((state) => {
        return {
          ...state,
          [field]: customertypedata,
        };
      });
      return customertypedata;
    }

    if (type === "company_name") {
      const { data } = rdata;

      let companynamedata = data.map((ite) => ({
        label: ite.value,
        value: ite.id,
      }));

      setApiData((state) => {
        return {
          ...state,
          [field]: companynamedata,
        };
      });

      return companynamedata;
    }
    if (type === "name") {
      const { data } = rdata;

      let companynamedata = data.map((ite) => ({
        label: ite.value,
        value: ite.id,
      }));

      setApiData((state) => {
        return {
          ...state,
          [field]: companynamedata,
        };
      });

      return companynamedata;
    }
    if (type == "project") {
      const project = rdata?.data?.map((ite) => ({
        label: ite.title,
        value: ite.customer_tattle_uuid,
        url: ite.url,
      }));

      setApiData((state) => {
        return {
          ...state,
          [field]: project,
        };
      });

      return project;
    }

    if (type == "external_api") {
      const resdata = Object.entries(rdata).map(([key, val]) => ({
        label: `${key} - ${val.title}`,
        value: key,
        url: val.url,
      }));
      return resdata;
    }
  };
  const validateFilterForm = () => {
    let hasValue = true;
    let obj = state.formdata;
    const { group_by, ...rest } = obj;
    for (let key in rest) {
      if (key === "custom_effort") {
        for (let nkey in obj["custom_effort"]) {
          if (
            obj["custom_effort"].hasOwnProperty(nkey) &&
            obj["custom_effort"][nkey] &&
            obj["custom_effort"][nkey].length > 0
          ) {
            hasValue = false;
            break;
          }
        }
      }
      if (key === "range") {
        for (let nkey in obj["range"]) {
          if (
            obj["range"].hasOwnProperty(nkey) &&
            obj["range"][nkey] &&
            obj["range"][nkey].length > 0
          ) {
            hasValue = false;
            break;
          }
        }
      }
      if (obj.hasOwnProperty(key) && obj[key] && obj[key].length > 0) {
        hasValue = false;
        break;
      }
    }
    return hasValue;
  };

  const deleteBlankKeys = (obj) => {
    for (let key in obj) {
      const value = obj[key];

      if (value === "" || value === null || value === undefined) {
        delete obj[key];
      } else if (Array.isArray(value) && value.length === 0) {
        delete obj[key];
      }
    }

    return obj;
  };

  const checkKanbanCondition = (item) => {
    if (item.field === "completed" && item.attribute_type == "checkbox") {
      const { options } = item;
      let newoptions = options.map((ite) => ({
        label: ite.option_name,
        value: ite._id,
      }));

      let completevalue = options
        .filter((it) => it._id == state.formdata[item.field])
        .map((itt) => ({ value: itt._id, label: itt.option_name }));
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelect
            options={newoptions}
            value={completevalue}
            // loadOptions={(evt) => getPeoplesCall(evt, item.api_url)}
            isClearable
            // components={{ Option: CustomOption }}
            // isMulti
            onChange={(evt) => handleFormChangeReactSelect(evt, item.field)}
          />
        </div>
      );
    }
    if (item.field === "replied") {
      let replieddata = [
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" },
      ];
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelect
            options={replieddata}
            value={replieddata.filter(
              (it) => it.value === state.formdata[item.field]
            )}
            onChange={(evt) => handleFormChangeReactSelect(evt, item.field)}
            isClearable={true}
          />
        </div>
      );
    }
    if (item.attribute_type === "text") {
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <input
            type="text"
            name={item.field}
            className="form-control"
            onChange={handleFormChange}
            value={state.formdata[item.field]}
          />
        </div>
      );
    }
    if (item.attribute_type === "age") {
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <input
            type="text"
            name={item.field}
            className="form-control"
            placeholder="Show age less than"
            onChange={handleFormChange}
            value={state.formdata[item.field]}
          />
        </div>
      );
    }

    if (item.attribute_type === "toggle") {
      let newval;
      newval = [
        { label: "Yes", value: true },
        { label: "No", value: false },
      ]?.filter((ke) => {
        return state.formdata[item.field]?.includes(ke.value);
      });

      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelectNew
            data={state.formdata}
            field={item.field}
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]}
            statusChangehandler={handleFormChangeReactSelect}
            open={false}
          />
        </div>
      );
    }
    if (item.attribute_type === "name") {
      let newval;
      newval = apiData?.[item.field]?.filter((ke) => {
        return state.formdata[item.field]?.includes(ke.value);
      });

      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <input
            type="text"
            name={"customer_name"}
            className="form-control"
            placeholder="Show age less than"
            onChange={handleFormChange}
            value={
              state.formdata[item.field] || state.formdata["customer_name"]
            }
          />
        </div>
      );
    }
    if (item.attribute_type === "assign_to") {
      const { Option } = components;

      const newval = state.users?.filter((itt) => {
        if (state.formdata[item.field]?.includes(itt.value)) {
          return itt;
        }
      });
      return (
        <div className="form-group mb-1">
          <label>
            {item.headerName}
            {/* {isKanban && <sup style={{ color: "red", fontSize: 12 }}>*</sup>} */}
          </label>{" "}
          {/* <AsyncSelect
            cacheOptions
            defaultOptions
            value={newval || ""}
            loadOptions={(evt) => getPeoplesCall(evt, item.api_url)}
            isClearable
            components={{ Option: CustomOption }}
            isMulti
            onChange={(evt) => handleFormChangeReactSelect(evt, item.field)}
          /> */}
          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            isAsync={true}
            open={false}
            options={state.users || []}
            data={state.formdata}
            apiUrl={item.api_url}
            getPeoplesCall={getPeoplesCall}
          />
          {/* {state?.error && (
            <div className="error">Please select at least one member</div>
          )} */}
        </div>
      );
    }
    if (item.attribute_type === "monitoring") {
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            isAsync={true}
            open={false}
            options={state.users || []}
            data={state.formdata}
            apiUrl={item.api_url}
            getPeoplesCall={getPeoplesCall}
          />
        </div>
      );
    }
    if (
      item.attribute_type === "reporter" ||
      item.attribute_type === "people"
    ) {
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            isAsync={true}
            open={false}
            options={state.users || []}
            data={state.formdata}
            apiUrl={item.api_url}
            getPeoplesCall={getPeoplesCall}
          />
        </div>
      );
    }
    if (item.attribute_type == "effort") {
      let options;
      if (item.options) {
        options = Object.keys(item.options).map((it) => ({
          label: item.options[it]?.name,
          value: it,
        }));
      }
      const newval = options?.filter((itt) => {
        if (
          state.formdata?.["custom_effort"]?.[item.field]?.includes(itt.value)
        ) {
          return itt;
        }
      });
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>

          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            open={false}
            options={options || []}
            data={state.formdata}
          />
        </div>
      );
    }
    if (item.attribute_type === "status") {
      const { options } = item;

      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            open={false}
            options={options}
            data={state.formdata}
          />
        </div>
      );
    }
    if (
      item.attribute_type === "select" ||
      item.attribute_type === "multi-select"
    ) {
      const { options } = item;
      let getOptionsSelect = options.map((item) => ({
        label: item.option_name,
        value: item._id,
      }));
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            open={false}
            options={getOptionsSelect}
            data={state.formdata}
          />
        </div>
      );
    }
    if (item.attribute_type === "priority") {
      const { options } = item;
      let getOptionsSelect = options.map((item) => ({
        label: item.option_name,
        value: item._id,
      }));

      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            open={false}
            options={getOptionsSelect}
            data={state.formdata}
          />
        </div>
      );
    }
    if (item.attribute_type === "category") {
      const { options } = item;
      let getOptionsSelect = options.map((item) => ({
        label: item.name,
        value: item._id,
      }));
      const newval = getOptionsSelect.filter((itt) => {
        if (state.formdata[item.field]?.includes(itt.value)) {
          return itt;
        }
      });
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            open={false}
            options={getOptionsSelect}
            data={state.formdata}
          />
        </div>
      );
    }
    if (item.attribute_type === "date" || item.attribute_type === "timestamp") {
      let edit_date;
      //        if(state.formdata && state.formdata['range'][item.field]){
      if (state.formdata && state.formdata.hasOwnProperty("range")) {
        edit_date =
          state.formdata["range"][item.field] &&
          state.formdata["range"][item.field].length
            ? state.formdata["range"][item.field].map((item) =>
                Number(item) ? new Date(item * 1000) : new Date(item)
              )
            : [];
      } else {
        let newval = state.formdata[item.field];
        if (newval && newval.length > 0) {
          if (newval !== undefined)
            edit_date = [new Date(newval[0]), new Date(newval[1])];
        }
      }
      
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <DateRangePicker
            className="custom-daterangepicker-menu custom-daterange"
            placeholder="dd-mm-yyyy ~ dd-mm-yyyy"
            format="dd-MM-yyyy"
            menuClassName="custom-daterangepicker-menu" // Styles the dropdown menu
            menuStyle={{ zIndex: 1100 }}
            showOneCalendar
            editable={false}
            value={edit_date || null}
            onChange={(evt) =>
              dateRangePickerHandler(evt, item.field, item.attribute_type)
            }
            onClean={(evt) =>
              dateRangePickerHandler(evt, item.field, item.attribute_type)
            }
            placement="auto"
          />
        </div>
      );
    }
    if (item.attribute_type === "start_date") {
      let edit_start_date;
      //        if(state.formdata && state.formdata['range'][item.field]){
      if (
        state.formdata &&
        state.formdata.hasOwnProperty("range") &&
        state.formdata.range.hasOwnProperty(item.field)
      ) {
        edit_start_date = state.formdata.range[item.field].map(
          (item) => new Date(item)
        );
      } else {
        let newval = state.formdata[item.field];
        if (newval && newval.length > 0) {
          if (newval !== undefined)
            edit_start_date =
              new Date(newval[0]) && new Date(newval[1])
                ? [new Date(newval[0]), new Date(newval[1])]
                : null;
        }
      }
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <DateRangePicker
            className="custom-daterange"
            placeholder="dd-mm-yyyy ~ dd-mm-yyyy"
            format="dd-MM-yyyy"
            menuStyle={{ zIndex: 1100 }}
            showOneCalendar
            editable={false}
            value={edit_start_date || null}
            onChange={(evt) => dateRangePickerHandler(evt, item.field)}
            placement="auto"
          />
        </div>
      );
    }
    if (item.attribute_type === "end_date") {
      let edit_end_date;
      //        if(state.formdata && state.formdata['range'][item.field]){
      if (state.formdata && state.formdata.hasOwnProperty("range")) {
        let newval = state.formdata["range"][item.field];
        if (newval !== null) {
          if (newval !== undefined)
            edit_end_date = [new Date(newval[0]), new Date(newval[1])];
        }
      } else {
        let newval = state.formdata[item.field];
        if (newval && newval.length > 0) {
          if (newval !== undefined)
            edit_end_date = [new Date(newval[0]), new Date(newval[1])];
        }
      }
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <DateRangePicker
            className="custom-daterange"
            placeholder="dd-mm-yyyy ~ dd-mm-yyyy"
            format="dd-MM-yyyy"
            menuStyle={{ zIndex: 1100 }}
            showOneCalendar
            editable={false}
            value={edit_end_date || null}
            onChange={(evt) => dateRangePickerHandler(evt, item.field)}
            placement="auto"
          />
        </div>
      );
    }
    if (item.attribute_type === "go_live_date") {
      let edit_go_live_date;
      //        if(state.formdata && state.formdata['range'][item.field]){
      if (state.formdata && state.formdata.hasOwnProperty("range")) {
        let newval = state.formdata["range"][item.field];
        if (newval !== null) {
          if (newval !== undefined)
            edit_go_live_date = [new Date(newval[0]), new Date(newval[1])];
        }
      } else {
        let newval = state.formdata[item.field];
        if (newval !== null) {
          if (newval !== undefined)
            edit_go_live_date = [new Date(newval[0]), new Date(newval[1])];
        }
      }
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <DateRangePicker
            className="custom-daterange"
            placeholder="dd-mm-yyyy ~ dd-mm-yyyy"
            format="dd-MM-yyyy"
            menuStyle={{ zIndex: 1100 }}
            showOneCalendar
            editable={false}
            value={edit_go_live_date || null}
            onChange={(evt) => dateRangePickerHandler(evt, item.field)}
            placement="auto"
          />
        </div>
      );
    }
    if (item.attribute_type === "customer") {
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <input
            type="email"
            className="form-control"
            name={item.field}
            value={state.formdata[item.field]}
            onChange={handleFormChange}
          />
        </div>
      );
    }
    if (item.attribute_type === "cc") {
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <input
            type="text"
            className="form-control"
            name={item.field}
            value={state.formdata[item.field]}
            onChange={handleFormChange}
          />
        </div>
      );
    }
    if (
      item.attribute_type === "customer_type" ||
      item.attribute_type === "account_manager" ||
      item.attribute_type === "sales_manager" ||
      item.attribute_type === "tse_owner"
    ) {
      let newval;
      newval = apiData?.[item.field]?.filter((ke) => {
        return state.formdata[item.field]?.includes(ke.value);
      });

      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>

          <ReactSelectNew
            getPeoplesCall={getApiCall}
            field={item.field}
            type={item.field}
            statusChangehandler={handleFormChangeReactSelect}
            apiUrl={item.api_url}
            isAsync={true}
            open={false}
            data={state.formdata}
            options={apiData[item?.attribute_type] || []}
          
          />
        </div>
      );
    }
    if (
      item.attribute_type === "company_name"
    ) {
      let newval;
      newval = apiData?.[item.field]?.filter((ke) => {
        return state.formdata[item.field]?.includes(ke.value);
      });

      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>

          <ReactSelectNew
            getPeoplesCall={getApiCall}
            field={item.field}
            type={item.field}
            statusChangehandler={handleFormChangeReactSelect}
            apiUrl={item.api_url}
            isAsync={true}
            open={false}
            data={state.formdata}
            options={apiData[item?.attribute_type] || []}
            serverSearch={true}
          />
        </div>
      );
    }
    if (item.attribute_type === "api" || item.attribute_type === "release") {
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>

          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            isAsync={true}
            open={false}
            apiData={apiData}
            type="api"
            options={apiData?.[item.field] || [] || []}
            data={state.formdata}
            apiUrl={item.api_url}
            getPeoplesCall={getApiCall}
          />
        </div>
      );
    }
    if (item.attribute_type === "product") {
      let newval;
      if (apiData?.[item.custom_field]?.length > 0) {
        newval = apiData?.[item.custom_field].filter((itt) => {
          if (state.formdata[item.custom_field]?.includes(itt.value)) {
            return itt;
          }
        });
      }

      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <ReactSelectNew
            statusChangehandler={handleFormChangeReactSelect}
            field={item.field}
            isAsync={true}
            open={false}
            apiData={apiData}
            type={item.attribute_type}
            options={apiData?.[item.field] || [] || []}
            data={state.formdata}
            apiUrl={item.api_url}
            getPeoplesCall={getApiCall}
          />
        </div>
      );
    }
    if (item.attribute_type === "er") {
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <AsyncSelect
            cacheOptions
            defaultOptions
            isMulti={true}
            loadOptions={(evt) =>
              getApiCall(evt, item.api_url, "er", item.field)
            }
            onChange={(evt) => handleFormChangeReactSelect(evt, item.field)}
          />
        </div>
      );
    }
    if (item.attribute_type === "board") {
      return (
        <div className="form-group mb-1">
          <label>{item.headerName}</label>
          <AsyncSelect
            cacheOptions
            defaultOptions
            loadOptions={(evt) =>
              getApiCall(evt, item.api_url, "board", item.field)
            }
            onChange={(evt) => handleFormChangeReactSelect(evt, item.field)}
          />
        </div>
      );
    }
  };

  const getFilterColumns = (columns, group) => {
    let options = [];

    if (group === "assign_to") {
      options = state.users.map((item) => ({
        label: item.name,
        value: item.user_uuid,
        profilePic: item.profile_image,
      }));
    } else {
      let attroptions =
        columns.find((item) => item.attribute_type === group)?.options ?? [];
      options = attroptions.map((it) => ({
        label: it.name || it.option_name,
        value: it._id,
      }));
    }

    return (
      <ReactSelect
        options={options}
        isClearable
        value={options.filter(
          (item) =>
            state.formdata.hasOwnProperty("columns") &&
            state.formdata.columns.includes(item.value || item.user_uuid)
        )}
        isMulti
        onChange={(evt) => handleFormChangeReactSelect(evt, "columns")}
      />
    );
  };

  const checkViewType = () => {
    const viewtype = new URLSearchParams(window.location.search).get("type");
    return viewtype;
  };

  const checkQueryExist = () => {
    const urlquery = new URLSearchParams(window.location.search).get("q");

    return urlquery;
  };

  const filterSubmitHandler = (evt) => {
    evt.preventDefault();
    const objs = deleteBlankKeys(state.formdata);

    let newobj = objs;
    if (isKanban) {
      newobj = objs;
      // if (!newobj.hasOwnProperty("assign_to")) {
      //   setState((state) => {
      //     return {
      //       ...state,
      //       error: true,
      //     };
      //   });
      //   return;
    } else {
      newobj = {
        ...delete newobj["group_by"],
        ...newobj,
      };
    }
    if (checkViewType() == "backlog" && checkQueryExist()) {
      const parsedata = JSON.parse(checkQueryExist());
      newobj = {
        ...newobj,
        ...parsedata,
        group_by: newobj.group_by,
      };
    }

    filterSubmit({ ...newobj, filter_id: values.filter_id });
  };

  const createFilterHandler = () => {
    const objs = deleteBlankKeys(state.formdata);
    let newobj = objs;
    if (isKanban) {
      newobj = objs;
      // if (!newobj.hasOwnProperty("assign_to")) {
      //   setState((state) => {
      //     return {
      //       ...state,
      //       error: true,
      //     };
      //   });
      //   return;
      // } else {
      //   setState((state) => {
      //     return {
      //       ...state,
      //       error: false,
      //     };
      //   });
      // }
    }
    if (filterText) {
      createFilterByView();
    }

    if (isEdit) {
      if (isKanban) {
        createFilterByView(state.formdata, values.filter_id);
      } else {
        const { group_by, ...rest } = state.formdata;
        createFilterByView(rest, values.filter_id);
      }
    } else {
      for (let key in state.formdata) {
        if (state.formdata.hasOwnProperty(key)) {
          if (
            typeof state.formdata[key] === "string" &&
            state.formdata[key] == ""
          ) {
            delete state.formdata[key];
          } else if (
            Array.isArray(state.formdata[key]) &&
            state.formdata[key].length === 0
          ) {
            delete state.formdata[key];
          }
        }
      }
      if (isKanban) {
        isFilterCreate(state.formdata);
      } else {
        const { group_by, ...rest } = state.formdata;
        isFilterCreate(rest);
      }
    }
  };

  let forms;
  if (state.columns.length > 0) {
    if (isKanban == true) {
      let newo = ["status", "assign_to", "priority", "category"];
      const colsopt = state.columns.filter((item) => item.show_group_by);

      let newvaluesarr = colsopt.map((ite) => ({
        label: ite.headerName,
        value: ite.field,
      }));
      let getval = newvaluesarr.filter((ite) => {
        if (state.formdata["group_by"] == ite.value) {
          return ite;
        }
      });
      forms = (
        <Form>
          <>
            <div className="form-group mb-1">
              <label>Group By</label>
              <ReactSelect
                options={newvaluesarr}
                value={getval}
                // loadOptions={(evt) => getPeoplesCall(evt, item.api_url)}
                isClearable
                // components={{ Option: CustomOption }}
                // isMulti
                onChange={(evt) => handleFormChangeReactSelect(evt, "group_by")}
              />
            </div>
            <div className="form-group mb-1">
              <label>Filter Columns</label>
              {getFilterColumns(state.columns, state.formdata.group_by)}
            </div>
            {state.columns.map((item) => {
              if (
                item.hasOwnProperty("show_in_kanban") &&
                item.show_in_kanban
              ) {
                return checkKanbanCondition(item);
              }
            })}
          </>
          <div className="action_bottom mt-3">
            <Button
              text={`Apply & Save`}
              className={`muBtn _blue ${
                validateFilterForm() ? "disabled" : ""
              }`}
              isDisabled={validateFilterForm()}
              type="button"
              onClick={createFilterHandler}
            />
            &nbsp;&nbsp;
            <Button
              text="Apply"
              type="submit"
              className={`muBtn _blue ${
                validateFilterForm() ? "disabled" : ""
              }`}
              onClick={filterSubmitHandler}
              isDisabled={validateFilterForm()}
            />
          </div>
        </Form>
      );
    } else {
      forms = (
        <Form>
          {state.columns.map((item, index) => {
            return checkKanbanCondition(item);
          })}
          <div className="action_bottom mt-3">
            <Button
              text={`Apply & Save`}
              className={`muBtn _blue ${
                validateFilterForm() ? "disabled" : ""
              }`}
              isDisabled={validateFilterForm()}
              type="button"
              onClick={createFilterHandler}
            />
            &nbsp;&nbsp;
            <Button
              text="Apply"
              type="submit"
              className={`muBtn _blue ${
                validateFilterForm() ? "disabled" : ""
              }`}
              onClick={filterSubmitHandler}
              isDisabled={validateFilterForm()}
            />
          </div>
        </Form>
      );
    }
  }
  return (
    <Offcanvas
      show={show}
      placement="end"
      onHide={onClose}
      className="my-canvas"
    >
      <Offcanvas.Header className="pb-2" closeButton>
        <Offcanvas.Title>
          {isEdit ? values?.filter_name : title}
        </Offcanvas.Title>{" "}
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0">
        {state.columns.length > 0 ? forms : <Loading />}
      </Offcanvas.Body>{" "}
    </Offcanvas>
  );
};

export default CustomFilter;
